import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getFile } from '../../services/fileService';
import Fallback from '../../components/common/Fallback';
import PrintFile from '../../components/prints/File';
import { generatePdfBlobUrlFromElement } from '../../utils/pdfPreview';

const FilePrintPage = () => {
  const { id } = useParams();
  const printRef = useRef(null);

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
  const [generatingPdf, setGeneratingPdf] = useState(false);

  const loadData = useCallback(async () => {
    setLoading(true);
    setNotFound(false);
    try {
      const data = await getFile(id);
      setFile(data);
    } catch (err) {
      console.error(err);
      if (err?.message?.toLowerCase().includes('not found')) {
        setNotFound(true);
      }
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const generatePdfPreview = useCallback(async () => {
    if (!printRef.current) return;
    setGeneratingPdf(true);
    try {
      const nextUrl = await generatePdfBlobUrlFromElement(printRef.current);
      setPdfUrl((prev) => {
        if (prev) URL.revokeObjectURL(prev);
        return nextUrl;
      });
    } finally {
      setGeneratingPdf(false);
    }
  }, []);

  useEffect(() => {
    if (!loading && file && !notFound) {
      const timer = setTimeout(() => {
        generatePdfPreview();
      }, 120);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [loading, file, notFound, generatePdfPreview]);

  useEffect(() => {
    return () => {
      if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    };
  }, [pdfUrl]);

  if (loading || !file) {
    return (
      <div className="page-wrapper">
        {loading && <p>Cargando ficha...</p>}
        {!loading && notFound && (
          <Fallback title="Ficha no encontrada" description="La ficha solicitada no existe." />
        )}
        {!loading && !notFound && <Fallback title="Error" description="Error al cargar la ficha." />}
      </div>
    );
  }

  return (
    <>
      {generatingPdf && <p>Generando previsualizacion PDF...</p>}
      {!generatingPdf && pdfUrl && (
        <iframe
          title="Previsualizacion ficha PDF"
          src={pdfUrl}
          style={{
            width: '100%',
            height: '100%',
            border: '1px solid #ddd',
            borderRadius: 8,
            background: '#fff'
          }}
        />
      )}

      <div
        aria-hidden
        style={{
          position: 'fixed',
          left: '-10000px',
          top: 0,
          width: 794,
          height: '100%',
          background: '#ffffff'
        }}
      >
        <div ref={printRef}>
          <PrintFile file={file} />
        </div>
      </div>
    </>
  );
};

export default FilePrintPage;
